import { IntegrationInputData, SlackChannelInput } from 'generated/graphql';
import { IntegrationChannelType } from 'generated/graphql';

export const getCreateSlackAndEmailIntegrationInput = (
  channelType: IntegrationChannelType,
  slackChannels: SlackChannelInput[],
  emails: string[],
): Pick<IntegrationInputData, 'slack' | 'emails'> => {
  if (channelType === IntegrationChannelType.Slack) {
    return {
      slack: {
        authGrant: '',
        subscribedChannels: slackChannels,
      },
    };
  }
  if (channelType === IntegrationChannelType.Email) {
    return {
      emails: {
        toEmails: emails,
      },
    };
  }
  return {};
};
